import { InformationAndServicesLinksSection, InformationAndServicesSectionToLinks, LinksSection, LinksSectionLink, SectionToLinks } from 'components/navigation/more-actions-menu/types';
import { Route } from 'config/routes';
import { createSelector } from 'reselect';
import { isConnectedUserSelector } from 'store/state/domainData/selectors';
import config from 'config';
import { showAgentConsoleBulletinFormSelector } from 'store/state/selectors/router';

const baseUrl = '/';

export const agentsLinks: LinksSectionLink[] = [
  { label: 'מאגר המתווכים', routeName: Route.MadadAgentPage, routeParams: { source: 'left_menu' } },
  { label: 'מדד המתווכים 2025/26', routeName: Route.MadadPage, routeParams: { source: 'left_menu' } },
  { label: 'מדד המתווכים 2024/25', routeName: Route.MadadArchivePage, routeParams: { year: 2025, source: 'left_menu' } },
  { label: 'מדד המתווכים 2023/24', routeName: Route.MadadArchivePage, routeParams: { year: 2024, source: 'left_menu' } },
  { label: 'מדד המתווכים 2022/23', routeName: Route.MadadArchivePage, routeParams: { year: 2023, source: 'left_menu' } },
  { label: 'מדד המתווכים 2021/22', routeName: Route.MadadArchivePage, routeParams: { year: 2022, source: 'left_menu' } },
];

export const informationAndServicesLinks: InformationAndServicesSectionToLinks = {
  [InformationAndServicesLinksSection.Main] : [
    { label: 'מדלן אישי', path: `${baseUrl}blog/מדלן-אישי/` },
    { label: 'הבלוק - בלוג הבית של מדלן', path: `${baseUrl}blog/` },
  ],
  [InformationAndServicesLinksSection.GuidesAndTools] : [
    { label: 'מחשבון מס רכישה', path: `${baseUrl}blog/מחשבון-מס-רכישה-2020/` },
    { label: 'מחשבון תשואות שכירות', path: `${baseUrl}blog/מחשבון-תשואת-שכירות-2022/` },
    { label: 'משכנתא',  rel: 'nofollow', externalPath: `${baseUrl}mortgage/articles`, externalParams: { source: 'left_menu' } },
    { label: 'מדריכים נוספים', path: `${baseUrl}blog/guides/` },
  ],
  [InformationAndServicesLinksSection.ManagementSystems] : [
    { label: 'מדלן ליזמים', rel: 'nofollow', externalPath: `${baseUrl}professional`, externalParams: { source: 'left_menu' } },
    { label: 'מדלן למתווכים', path: `${baseUrl}proAgent`, rel: 'nofollow' },
    { label: 'MadlanX', path: config.madlanXUrl },
  ],
};

export const staticLinksSelector = createSelector([
  isConnectedUserSelector,
  showAgentConsoleBulletinFormSelector,
], (isUser, showAgentConsoleBulletinForm): SectionToLinks => ({
  [LinksSection.Localize]: [
    { label: 'פרסום ליזמים', routeName: Route.DevelopersPromotionPage, routeParams: { source: 'left_menu' } },
    { label: 'פרסום למתווכים', routeName: Route.AgentsPromotionPage, routeParams: { source: 'left_menu' } },
    { label: 'מי אנחנו', externalPath: `${baseUrl}etc/aboutUs`, externalParams: { source: 'left_menu' } },
    { label: 'שאלות נפוצות', externalPath: 'https://help.madlan.co.il/hc/he/categories/29518300674461-%D7%A9%D7%90%D7%9C%D7%95%D7%AA-%D7%95%D7%AA%D7%A9%D7%95%D7%91%D7%95%D7%AA-%D7%9C%D7%92%D7%95%D7%9C%D7%A9%D7%99-%D7%9E%D7%93%D7%9C%D7%9F', externalParams: { source: 'left_menu' } },
    { label: 'צרו קשר', externalPath: `${baseUrl}lp/connectUs`, externalParams: { source: 'left_menu' } },
    { label: 'הצהרת נגישות', routeName: Route.Accessibility, routeParams: { source: 'left_menu' } },
  ],
  [LinksSection.Guides]: [
    { label: 'מדריך ערים', rel: 'nofollow', externalPath: `${baseUrl}local/pricesHeatmap`, externalParams: { source: 'left_menu' } },
    { label: 'משכנתא', rel: 'nofollow', externalPath: `${baseUrl}mortgage/articles`, externalParams: { source: 'left_menu' } },
    { label: 'אינדקס יזמים', routeName: Route.DevelopersSearchPage, routeParams: { source: 'left_menu' } },
    { label: 'מאגר המתווכים', routeName: Route.MadadAgentPage, routeParams: { source: 'left_menu' } },
    { label: 'מדד המתווכים של מדלן 2025/26', routeName: Route.MadadPage, routeParams: { source: 'left_menu' } },
    { label: 'מדד המתווכים של מדלן 2024/25', routeName: Route.MadadArchivePage, routeParams: { year: 2025, source: 'left_menu' } },
    { label: 'מדד המתווכים של מדלן 2023/24', routeName: Route.MadadArchivePage, routeParams: { year: 2024, source: 'left_menu' } },
    { label: 'מדד המתווכים של מדלן 2022/23', routeName: Route.MadadArchivePage, routeParams: { year: 2023, source: 'left_menu' } },
    { label: 'מדד המתווכים של מדלן 2021/22', routeName: Route.MadadArchivePage, routeParams: { year: 2022, source: 'left_menu' } },
    { label: 'מחשבון מס רכישה', externalPath: `//www.madlan.co.il/blog/מחשבון-מס-רכישה-2020`, externalParams: { source: 'left_menu' } },
  ],
  [LinksSection.Tools]: [
    (showAgentConsoleBulletinForm ? { label: 'מדלן למתווכים', rel: 'nofollow', path: `${baseUrl}console/agent/home?source=left_menu` } : null),
    { label: 'מדלן ליזמים', rel: 'nofollow', externalPath: `${baseUrl}professional`, externalParams: { source: 'left_menu' } },
  ].filter(Boolean),
  [LinksSection.ManageBulletin]: [
    {
      label: 'העלאת מודעה',
      routeName: showAgentConsoleBulletinForm ? Route.UploadBulletinForm : Route.UploadBulletin,
      routeParams: { source: 'left_menu' },
    },
    ...(isUser
      ? (showAgentConsoleBulletinForm
        ? [ { label: 'מערכת מתווכים', hideInApp: true, routeName: Route.AgentConsoleHomePage, routeParams: { source: 'left_menu' } } ]
        : [ { label: 'מודעות שפרסמתי', routeName:  Route.ManageBulletins, routeParams: { source: 'left_menu' } } ]
      ) : []),
  ].filter(Boolean),
}));
